/** Textes par défaut du site — doivent refléter les textes affichés sur les pages publiques. */
export const DEFAULT_TEXTS = {
  quote_banner_label: "Citation cornemuse du jour",
  home_gallery_label: "Instant Cliché",
  home_gallery_title: "L'Énergie du Direct",
  home_gallery_text: "De la première bourrée au cercle final, des moments de partage capturés sur le vif.",
  home_gallery_link: "Voir toute la galerie →",
  home_prestas_title: "Nos Formules Scéniques",
  home_prestas_text: "Des propositions clés en main pour mairies, associations, festivals et événements privés.",
  home_hero_caption: "Un collectif de musiciens passionnés — cornemuses du Centre-France, accordéons, chant — qui fait danser bals, fêtes et festivals sur la côte et bien au-delà.",
  home_ambiance_label: "L'Esprit des Sonneurs",
  home_ambiance_title: "Une énergie communicative, du premier au dernier morceau",
  home_ambiance_box_title: "Notre engagement scénique",
  home_ambiance_box_text: "Adaptation aux contraintes de chaque lieu, autonomie sonore pour les jauges moyennes et respect des horaires de fête.",
  home_ambiance_image_caption: "Ambiance 100% Vivante",
  home_ambiance_image_sub: "Des bals inoubliables partagés avec les danseurs",
  agenda_label: "En Direct",
  agenda_title: "Prochaines Dates",
  agenda_invite: "Inviter le groupe sur votre date →",
  home_news_label: "La vie du groupe",
  home_news_title: "Actualités",
  home_cta_title: "Envie d'un bal trad chez vous ?",
  home_cta_text: "Mairie, association, festival ou fête privée : racontez-nous votre projet, nous répondons sous 48h.",
  home_cta_button: "Organiser un événement",
  page_prestations_label: "Nos animations",
  page_prestations_title: "Prestations",
  page_prestations_intro: "Bals trad, initiations aux danses traditionnelles, accompagnement de cérémonies de commémoration et stages de musique trad : quatre formules pensées pour les mairies, les associations, les festivals et les particuliers.",
  page_galerie_label: "Souvenirs & enregistrements",
  page_galerie_title: "Galerie",
  page_galerie_intro: "Photos, vidéos et enregistrements de nos bals, scènes et stages — l'ambiance des Sonneurs comme si vous y étiez.",
  page_actualites_label: "En direct du groupe",
  page_actualites_title: "Actualités",
  page_actualites_intro: "Prochaines dates, comptes-rendus de bals et vie du groupe : tout ce qu'il se passe chez Les Sonneurs de la Côte.",
  page_contact_label: "Demande de date",
  page_contact_title: "Contact",
  page_contact_intro: "Une prestation à organiser, un projet à nous raconter ? Écrivez-nous, nous répondons sous 48h.",
  page_association_label: "Association loi 1901",
  page_association_title: "L'Association",
  page_association_intro: "Derrière les bals et les scènes, une équipe de bénévoles passionnés qui fait vivre la cornemuse et la danse traditionnelle.",
  nav_cta_label: "Réserver le groupe",
  hero_cta_label: "Demander un devis pour votre fête",
  hero_secondary_label: "Découvrir nos prestations",
  page_stages_label: "Apprendre & transmettre",
  page_stages_title: "Stages",
  page_stages_intro: "Stages de musique traditionnelle : cornemuse du Centre-France et répertoire de bal, encadrés par des musiciens pédagogues.",
  stages_organizing_title: "Prochain stage en cours d'organisation",
  stages_organizing_text: "Les inscriptions ouvriront bientôt — laissez-nous vos coordonnées via le formulaire ci-dessous pour être prévenu en premier.",
  stages_form_title: "Inscription & pré-inscription",
  home_news_badge: "Actualité",
  home_news_link: "Toutes les actualités →",
  home_prestas_card_link: "Réserver cette formule →",
  page_prestations_card_link: "Demander cette prestation →",
  prestas_box_title: "Une envie particulière ?",
  prestas_box_text: "Chaque événement est unique : parlez-nous de votre projet et nous construisons une animation sur mesure.",
  prestas_box_button: "Nous écrire",
  galerie_audio_title: "Nos enregistrements",
  galerie_audio_link: "Écouter nos enregistrements →",
  page_audio_label: "Écouter",
  page_audio_title: "Nos enregistrements",
  page_audio_intro: "Quelques airs de notre répertoire, enregistrés au fil des bals et des répétitions — montez le son !",
  audio_hint: "Cliquez sur la cornemuse pour écouter un air, une deuxième fois pour l'arrêter.",
  legal_notice_text:
    "**Les Sonneurs de la Côte**\nAssociation n° RNA : W626001985\nN° Siret : 82940944000023\nSiège social : 13, rue de Moscou — 62100 Calais\nE-mail : sonneursdelacote62@gmail.com\n\nResponsable de la publication : {president}\n\n**Hébergeur**\nInfinityFree — Kwikstaartlaan 42, Unit G1517, 3704 GS Zeist, Pays-Bas\nContact : hello@infinityfree.com",
  legal_privacy_text:
    "Ce site n'utilise pas de cookies et ne collecte aucune information de trafic ni aucune donnée personnelle de navigation.\n\nLorsque vous nous écrivez via le formulaire de contact ou le formulaire d'inscription aux stages, les informations transmises (nom, adresse e-mail et contenu du message) servent uniquement à répondre à votre demande et sont conservées uniquement le temps de la conversation.\n\nAucune donnée n'est revendue ni partagée avec des tiers.\n\nPour toute question ou demande concernant vos données, vous pouvez écrire à : sonneursdelacote62@gmail.com",
  galerie_audio_hint: "Cliquez sur la cornemuse pour écouter un air, une deuxième fois pour l'arrêter.",
};
